import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  ApiService,
  AuthService,
  InterceptorConfig,
  RequestMetadata
} from '@financial/arch';
import { LoginResult, LoginValidator } from '@financial/common-pages';
import { Observable, of } from 'rxjs';
import * as CriptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class LoginService implements LoginValidator {
  protected metadata: RequestMetadata = { autoCatch: InterceptorConfig.NO_INTERCEPT };
  constructor(
    private api: ApiService,
    private authService: AuthService,
    private router: Router
  ) { }

  async validateLogin(username: string, password: string): Promise<LoginResult> {
    if (!username || !password) {
      return LoginResult.fail('Credenciais inválidas');
    } else {
      try {
        const token = await this.getFinancialToken(username, password).toPromise();
        return this.handleToken(token, this.authService);
      } catch (err) {
        console.error(err);
        return LoginResult.fail();
      }
    }
  }

  private getFinancialToken(username: string, password: string): Observable<string> {
    const split = username.split('@');
    if (split.length !== 2) {
      return of(null);
    } else {
      const user = split[0];
      const enterprise = split[1];
      return this.api.root.path(`login`).getText({
        headers: new HttpHeaders().set(
          'Authorization',
          `Basic ${btoa(`${user}@${enterprise}:${password}`)}`
        ),
        metadata: this.metadata
      });
    }
  }

  private handleToken(token: string, authService: AuthService): LoginResult {
    if (token) {
      authService.publishLogin(token);
      this.router.navigate(['/']);
      return LoginResult.success();
    } else {
      return LoginResult.fail();
    }
  }
}
